import { Movie } from '../index';
import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
import useStyles from './Styles';
const RatedCard = ({ title, movies }) => {
    const classes = useStyles();
  return (
      <div>
        <Box>
      <Typography variant="h5" gutterBottom>{title}</Typography>
      <Box display="flex" flexWrap="wrap" className={classes.container}>
        {movies.results.map((movie, i) => (
          <Movie key={movie.id} movie={movie} i={i} />
        ))}
      </Box>
    </Box>
    </div>
  )
}

export default RatedCard